export const GROUP_COLORS = ['#2489FF', '#0DCB86', '#FFC149', '#FF555F', '#FF8BC3', '#4324FF', '#F1E151', '#C9C9C9']
